exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group_body {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .group_body .name_field.notAllowed {\n    cursor: not-allowed; }\n  .group_body .nodeForm {\n    display: contents; }\n\nbutton {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n\n.search_input {\n  height: 40px;\n  padding: 1rem;\n  background: #ededed; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/node-edit-dialog/node-edit-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/node-edit-dialog/node-edit-dialog.component.scss
// module chunks = main